

<h2 mat-dialog-title>Find and Set Lot</h2>
<mat-dialog-content class="mat-typography">
    
    <div class="row ml-2 mt-3" style="margin-left:5px;">
        <div class="col-12">
            Current Default Lot: <strong>{{this._appGeneralState.currentLotNumber}} - {{this._appGeneralState.currentLotName}} </strong>
        </div>
    </div>

        <div style="margin-left:20px;margin-top:20px;">

        <span style="font-size:14px;font-weight: bold;">Find Lot</span>   
         <br />   
        <form 
        (ngSubmit)="onSetNewLot()" 
        class="example-form" 
            style="margin-top:20px"
            [formGroup]="findLotForm">
                <mat-form-field class="example-full-width">
                    <mat-label>Enter lot number or name</mat-label>
                    <input type="text"
                        placeholder="Enter lot number or name"
                        aria-label="Number"
                        matInput
                        formControlName="lotFind"
                        [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption >
                    @for (option of filteredOptions | async; track option) {
                        <mat-option [value]="option">{{option}}</mat-option>
                    }
                    </mat-autocomplete>
                </mat-form-field>
                <div class="row text-end">
                    <div class="col-8"></div>
                    <div class="col-4">
                        <button type="submit" class="btn btn-primary mt-3" style="margin-left:0px;" [disabled]="!findLotForm.valid == true || !this.clearedToSaveNewLot" >Set Default Lot</button>
                    </div>
                    
                </div>
                
            </form>

            @if(clearedToSaveNewLot){
                <span class="material-icons" style="color:green;">
                    location_pin
                    </span>
                    <span style="position:relative; top:-5px">The Lot entered above is valid and ready to set as your default Lot</span>
            }
            @else{
                <span class="material-icons" style="color:red">
                    not_listed_location
                    </span>
                    <span  style="position:relative; top:-5px">Invalid Lot - Select Lot from List</span>
            }

        </div>
    
    
    

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close & Keep Current Default Lot</button>
  </mat-dialog-actions>
